module.exports = __webpack_public_path__ + "static/media/tiktok.f3226c48.png";